export const Highway = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.39062 7.39067L2.78125 21.2188H21.2187L16.6094 7.39067M7.39062 7.39067L5.85418 12H2.78125V2.78125H21.2187V11.9999L18.1458 12L16.6094 7.39067M7.39062 7.39067H16.6094M12 16.6094V21.2188M12 10.4649V13.5378"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
